module.exports = ".titulo {\r\n  color: #666;\r\n}\r\n\r\n.search-mercadorias {\r\n  max-width: 250px;\r\n  padding-bottom: 50px;\r\n  margin: left;\r\n}\r\n"